import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSparkle = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20 25C21.3261 25 22.5979 24.4732 23.5355 23.5355C24.4732 22.5979 25 21.3261 25 20C25 21.3261 25.5268 22.5979 26.4645 23.5355C27.4021 24.4732 28.6739 25 30 25",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 25C21.3261 25 22.5979 25.5268 23.5355 26.4645C24.4732 27.4021 25 28.6739 25 30C25 28.6739 25.5268 27.4021 26.4645 26.4645C27.4021 25.5268 28.6739 25 30 25",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 15C10.6566 15 11.3068 14.8707 11.9134 14.6194C12.52 14.3681 13.0712 13.9998 13.5355 13.5355C13.9998 13.0712 14.3681 12.52 14.6194 11.9134C14.8707 11.3068 15 10.6566 15 10C15 11.3261 15.5268 12.5979 16.4645 13.5355C17.4021 14.4732 18.6739 15 20 15",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 15C10.6566 15 11.3068 15.1293 11.9134 15.3806C12.52 15.6319 13.0712 16.0002 13.5355 16.4645C13.9998 16.9288 14.3681 17.48 14.6194 18.0866C14.8707 18.6932 15 19.3434 15 20C15 18.6739 15.5268 17.4021 16.4645 16.4645C17.4021 15.5268 18.6739 15 20 15",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 27H15",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 25V29",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 13H29",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27 11V15",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgSparkle);
export default ForwardRef;
